<div class="reportSpacing">
  <div>
    <div>
      <!-- Piqet Logo & Organization Logo -->
      <div
        class="logo-div d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-start align-items-md-center"
      >
        <div class="m-0 p-0">
          <img [src]="piqetLogo" id="piqetLogo" alt="Piqet logo" />
        </div>
        <div class="m-0 p-0">
          <img
            [src]="reportData?.organizationLogo"
            id="organizationLogo"
            alt="Organization image"
          />
        </div>
      </div>

      <!-- Project name -->
      <div class="main-contant">
        <div class="maintext-heading">
          <span class="purpleProjectName">{{ mainProjectName | titlecase }}</span>
          {{ remainingProjectName | titlecase }} -
          <br />
          {{ reportResource.lblDetailedReport }}
        </div>
      </div>
      <!-- Scenario Image List -->
      <div *ngIf="reportData?.scenarioImageList">
        <div *ngFor="let scenarioImage of reportData?.scenarioImageList">
          <img src="scenarioImage" class="scenarioImage" alt="Scenario image" />
        </div>
      </div>
      <!-- Profile Image -->
      <div class="profile-detail-div">
        <div class="profile-image-div">
          <img [src]="'data:image/jpg;base64,' + reportData?.profileImage" alt="Profile image" />
        </div>
        <div class="profile-detail">
          <p class="userNameOrorganization">{{ reportData?.username }}</p>
        </div>
      </div>
      <!-- Organization name -->
      <div class="organizatio-name-div">
        <div class="organizatio-name">
          <p class="userNameOrorganization">{{ reportData?.organizationName }}</p>
        </div>
      </div>

      <div class="bottom-contant">
        <div class="">Generated by</div>
        <div class="">George heathcote</div>
        <div class="">Other.side studio</div>
      </div>

      <div class="last-bottom-contant">
        <div class="">PIQET project code : {{ reportData?.projectCode }}</div>
        <div class="">Report generated : {{ getFormateDate(reportData?.reportGeneratedDate) }}</div>
        <div class="">Software version : PIQET {{ reportData?.softwareVersion }}</div>
      </div>
    </div>
  </div>

  <div>
    <div class="reportContent">
      <!-- Project detail -->
      <div class="project-detail-div page-break">
        <!-- Title -->
        <div class="row space">
          <h1 class="headingTitle">Project details</h1>
        </div>
        <!-- Table & Table title -->
        <div class="row table-div">
          <div class="tableHeading">
            <h3>{{ reportResource.lblSummaryProject }}</h3>
          </div>
          <div class="table-content">
            <table class="table">
              <thead>
                <tr>
                  <td>PIQET project code</td>
                  <td>{{ reportData?.projectCode }}</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Name</td>
                  <td>{{ reportData?.projectName }}</td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>{{ reportData?.projectDescription }}</td>
                </tr>
                <tr>
                  <td>Share with</td>
                  <td>{{ reportData?.shareWith }}</td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td>{{ reportData?.status }}</td>
                </tr>
                <tr>
                  <td>Currency</td>
                  <td>{{ reportData?.currency }}</td>
                </tr>
                <tr>
                  <td>Default country</td>
                  <td>{{ reportData?.defaultCountry }}</td>
                </tr>
                <tr>
                  <td>Other countries</td>
                  <td>{{ reportData?.otherCountries }}</td>
                </tr>
                <tr>
                  <td>Basic for comparison</td>
                  <td>{{ reportData?.basisforComparision }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <br />
        <br />
        <!-- Table & Table title -->
        <div class="row table-div">
          <div class="tableHeading">
            <h3>{{ reportResource.lblSummaryScenarios }}</h3>
          </div>
          <div class="table-content">
            <table class="table">
              <thead>
                <tr>
                  <td>Package product system</td>
                  <td>Package</td>
                  <td>Product</td>
                  <td>Product quantity</td>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let scenario of reportData?.propackscenarioList">
                  <td>{{ scenario.propackScenarioname }}</td>
                  <td>{{ scenario.package }}</td>
                  <td>{{ scenario.productSector }}</td>
                  <td>{{ scenario.productQuantity }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="page-break"></div>
      <div style="margin-top: 20px">
        <div class="row space">
          <h1 class="headingTitle">{{ reportResource.lblProductLoss }}</h1>
        </div>
        <div>
          <p class="para">{{ reportResource.lblProductLossImpact }}</p>
          <p class="para">{{ reportResource.lblProductWaste }}</p>
        </div>
      </div>
      <div
        *ngFor="let indicatorDetail of reportData.productLossContributionImpactItems; let i = index"
      >
        <div [ngClass]="i == 0 ? '' : 'page-break'"></div>
        <h3 class="indicatorName">
          <span class="Titalcase">{{ indicatorDetail.indicatorName }}</span
          >&nbsp; ({{ indicatorDetail.indicatorUnitName }})
        </h3>
        <div class="tableHeadingForLifecycleStage">
          <h3>
            {{ reportResource.lblTable }} {{ tableId + i }}: {{ indicatorDetail.indicatorName }}
            {{ reportResource.lblContributionProductWaste }} -
            {{ reportData?.functionalUnitName | lowercase }}
          </h3>
        </div>
        <div style="margin-bottom: 30px">
          <piqet-angular-report-bar-chart
            [impactItems]="indicatorDetail.impactItems"
          ></piqet-angular-report-bar-chart>
        </div>
        <p class="figureIdClass">
          Figure {{ lblProductLossFigureId + i }} {{ indicatorDetail.indicatorName }} comparison of
          {{ reportResource.lblContributionProductWaste }} -
          {{ reportData.functionalUnitName | lowercase }}
        </p>
      </div>
    </div>
  </div>
</div>
